// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.10.0
//   protoc               v6.33.5
// source: notification.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from '@bufbuild/protobuf/wire';

export const protobufPackage = 'notification';

/** 统一的消息内容定义 */
export interface MessageContent {
  /** 类型: "match" 或 "odds" 或 "match_change" 或 "odds_recommend" */
  type: string;
  /** 比赛ID */
  matchId: string;
  /** 比赛数据 (当type="match"时使用) */
  matchData?: MatchData | undefined;
  /** 赔率数据数组 (当type="odds"时使用) */
  oddsData?: OddsDataList | undefined;
  leftSportCountData?: LeftSportCountData | undefined;
  topSportCountData?: TopSportCountData | undefined;
  /** 赔率推荐数据 (当type="odds_recommend"时使用) */
  oddsRecommendData?: OddsRecommendData | undefined;
}

export interface LeftSportCountData {
  sportCount: number;
  sportId: string;
  sportName: string;
  tournamentCount: number;
  tournamentId: string;
  tournamentName: string;
  type: string;
  timestamp: number;
  categoryCount: number;
  categoryId: string;
}

/** 赛事直播数据定义 */
export interface TopSportCountData {
  /** 比赛数量 */
  liveSportCount: number;
  /** 运动ID */
  liveSportId: string;
  /** 运动名称 */
  liveSportName: string;
  /** 赛事数量 */
  upComingSportCount: number;
  /** 赛事ID */
  upComingSportId: string;
  /** 赛事名称 */
  upComingSportName: string;
  /** 排序 */
  sort: number;
  /** 时间戳 */
  timestamp: number;
}

/** 比赛数据定义 */
export interface MatchData {
  /** 比赛ID或URN */
  id: string;
  /** 赛季ID */
  seasonId: string;
  /** 赛季名称 */
  seasonName: string;
  /** 赛季年份 */
  seasonYear: string;
  /** 比赛名称 */
  name: string;
  /** 主队ID */
  homeId: string;
  /** 主队名称 */
  homeName: string;
  /** 主队Logo URL */
  homeLogoUrl: string;
  /** 主队球衣 */
  homeJersey: string;
  /** 客队ID */
  awayId: string;
  /** 客队名称 */
  awayName: string;
  /** 客队Logo URL */
  awayLogoUrl: string;
  /** 客队球衣 */
  awayJersey: string;
  /** 场馆ID */
  venueId: string;
  /** 场馆名称 */
  venueName: string;
  /** 裁判ID */
  refereeId: string;
  /** 裁判名称 */
  refereeName: string;
  /** 比赛类型 */
  type: string;
  /** 分组ID */
  groupId: string;
  /** 分组名称 */
  groupName: string;
  /** 阶段（例如：小组赛、淘汰赛） */
  phase: string;
  /** 其他比赛ID */
  otherMatchId: string;
  /** 联赛轮次 */
  tournamentRound: string;
  /** 计划开始时间（Unix时间戳，毫秒） */
  scheduledTime: number;
  /** 计划结束时间（Unix时间戳，毫秒） */
  scheduledEndTime?: number | undefined;
  /** 比赛时钟（例如：15:00） */
  matchTime: string;
  /** 事件状态 (0:未开始, 1:进行中, 2:已结束) */
  status: number;
  /** 事件状态名称 */
  statusName: string;
  /** 主队得分 */
  homeScore: number;
  /** 客队得分 */
  awayScore: number;
  /** 主队点球得分 */
  homePenaltyScore: number;
  /** 客队点球得分 */
  awayPenaltyScore: number;
  /** 补时时间 */
  stoppageTime: string;
  /** 宣布的补时时间 */
  stoppageTimeAnnounced: string;
  /** 剩余比赛时间 */
  remainingTime: string;
  /** 当前周期剩余时间 */
  remainingTimeInPeriod: string;
  /** 是否暂停 */
  stopped: boolean;
  /** 报告状态 (例如: live, delayed) */
  reporting: number;
  /** 比赛状态 */
  matchStatus: number;
  /** 比赛状态名称 */
  matchStatusName: string;
  /** 获胜方ID */
  winnerId: string;
  /** 节/局/盘得分信息列表 */
  periodScores: MatchPeriodScoreDto[];
  /** 体育事件状态 */
  sportEventStatus?: SportEventStatusDto | undefined;
}

/** 比赛节/局/盘得分DTO，用于实时更新比分和状态 */
export interface MatchPeriodScoreDto {
  /** 主队当前总得分 */
  homeScore: number;
  /** 客队当前总得分 */
  awayScore: number;
  /** 比赛状态码 */
  matchStatusCode: number;
  /** 当前的节/局/盘编号 (e.g., 1 for 1st half, 2 for 2nd half) */
  number: number;
}

/** 比赛时钟DTO */
export interface EventClockDto {
  /** 比赛时钟（例如：15:00） */
  matchTime: string;
  /** 补时时间 */
  stoppageTime: string;
  /** 宣布的补时时间 */
  stoppageTimeAnnounced: string;
  /** 剩余比赛时间 */
  remainingTime: string;
  /** 当前周期剩余时间 */
  remainingTimeInPeriod: string;
  /** 是否暂停 */
  stopped: boolean;
}

/** 体育事件状态DTO */
export interface SportEventStatusDto {
  /** 比赛时钟信息 */
  clock: EventClockDto | undefined;
  /** 节/局/盘得分信息列表 */
  periodScores: MatchPeriodScoreDto[];
  /** 事件状态 */
  status: number;
  /** 事件状态名称 */
  statusName: string;
  /** 比赛状态 */
  matchStatus: number;
  /** 比赛状态名称 */
  matchStatusName: string;
  /** 主队得分 */
  homeScore: number;
  /** 客队得分 */
  awayScore: number;
  /** 主队点球得分 */
  homePenaltyScore: number;
  /** 客队点球得分 */
  awayPenaltyScore: number;
  /** 主队游戏得分 */
  homeGamescore: number;
  /** 客队游戏得分 */
  awayGamescore: number;
  /** 主队回合得分 */
  homeLegscore: number;
  /** 客队回合得分 */
  awayLegscore: number;
  /** 当前发球方 */
  currentServer: number;
  /** 加速模式 */
  expediteMode: boolean;
  /** 抢七 */
  tiebreak: boolean;
  /** 主队暂停 */
  homeSuspend: number;
  /** 客队暂停 */
  awaySuspend: number;
  /** 球数 */
  balls: number;
  /** 击球数 */
  strikes: number;
  /** 出局数 */
  outs: number;
  /** 垒位 */
  bases: string;
  /** 主队击球手 */
  homeBatter: number;
  /** 客队击球手 */
  awayBatter: number;
  /** 投手 */
  pitcher: string;
  /** 击球手 */
  batter: string;
  /** 投球数 */
  pitchCount: number;
  /** 看到的投球数 */
  pitchesSeen: number;
  /** 总命中数 */
  totalHits: number;
  /** 总投球数 */
  totalPitches: number;
  /** 控球权 */
  possession: number;
  /** 位置 */
  position: number;
  /** 尝试次数 */
  getTry: number;
  /** 码数 */
  yards: number;
  /** 传球次数 */
  getThrow: number;
  /** 访问次数 */
  visit: number;
  /** 剩余红球 */
  remainingReds: number;
  /** 交付次数 */
  delivery: number;
  /** 主队剩余投球 */
  homeRemainingBowls: number;
  /** 客队剩余投球 */
  awayRemainingBowls: number;
  /** 当前结束 */
  currentEnd: number;
  /** 局数 */
  innings: number;
  /** 回合 */
  over: number;
  /** 主队罚分 */
  homePenaltyRuns: number;
  /** 客队罚分 */
  awayPenaltyRuns: number;
  /** 主队出局数 */
  homeDismissals: number;
  /** 客队出局数 */
  awayDismissals: number;
  /** 当前CT队伍 */
  currentCtTeam: number;
  /** 领先方周期 */
  periodOfLeader: number;
  /** 主队推进次数 */
  homeDriveCount: number;
  /** 客队推进次数 */
  awayDriveCount: number;
  /** 主队比赛次数 */
  homePlayCount: number;
  /** 客队比赛次数 */
  awayPlayCount: number;
}

/** 赔率数据列表定义 */
export interface OddsDataList {
  data: OddsData[];
}

/** 赔率数据定义 */
export interface OddsData {
  /** 赔率代码 */
  code: string;
  /** 赔率值 */
  value: number;
  /** 状态 */
  status: number;
  /** 更新时间 (驼峰命名) */
  updateTime: number;
  /** 盘口状态 */
  marketStatus: number;
  /** 0-赛前/1-滚球 (可选, 冠军盘没有) */
  phase?: number | undefined;
  /** 盘口id */
  marketId: string;
  /** 盘口specifiers */
  specifiers: string;
}

/** 赔率数据定义 */
export interface OddsRecommendData {
  /** sportId */
  sportId: string;
  /** matchId */
  matchId: string;
  /** 展示模式 */
  modes: number[];
}

function createBaseMessageContent(): MessageContent {
  return {
    type: '',
    matchId: '',
    matchData: undefined,
    oddsData: undefined,
    leftSportCountData: undefined,
    topSportCountData: undefined,
    oddsRecommendData: undefined,
  };
}

export const MessageContent: MessageFns<MessageContent> = {
  encode(message: MessageContent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== '') {
      writer.uint32(10).string(message.type);
    }
    if (message.matchId !== '') {
      writer.uint32(18).string(message.matchId);
    }
    if (message.matchData !== undefined) {
      MatchData.encode(message.matchData, writer.uint32(26).fork()).join();
    }
    if (message.oddsData !== undefined) {
      OddsDataList.encode(message.oddsData, writer.uint32(34).fork()).join();
    }
    if (message.leftSportCountData !== undefined) {
      LeftSportCountData.encode(message.leftSportCountData, writer.uint32(42).fork()).join();
    }
    if (message.topSportCountData !== undefined) {
      TopSportCountData.encode(message.topSportCountData, writer.uint32(50).fork()).join();
    }
    if (message.oddsRecommendData !== undefined) {
      OddsRecommendData.encode(message.oddsRecommendData, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessageContent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessageContent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.matchId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.matchData = MatchData.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.oddsData = OddsDataList.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.leftSportCountData = LeftSportCountData.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.topSportCountData = TopSportCountData.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.oddsRecommendData = OddsRecommendData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessageContent {
    return {
      type: isSet(object.type) ? globalThis.String(object.type) : '',
      matchId: isSet(object.matchId) ? globalThis.String(object.matchId) : '',
      matchData: isSet(object.matchData) ? MatchData.fromJSON(object.matchData) : undefined,
      oddsData: isSet(object.oddsData) ? OddsDataList.fromJSON(object.oddsData) : undefined,
      leftSportCountData: isSet(object.leftSportCountData)
        ? LeftSportCountData.fromJSON(object.leftSportCountData)
        : undefined,
      topSportCountData: isSet(object.topSportCountData)
        ? TopSportCountData.fromJSON(object.topSportCountData)
        : undefined,
      oddsRecommendData: isSet(object.oddsRecommendData)
        ? OddsRecommendData.fromJSON(object.oddsRecommendData)
        : undefined,
    };
  },

  toJSON(message: MessageContent): unknown {
    const obj: any = {};
    if (message.type !== '') {
      obj.type = message.type;
    }
    if (message.matchId !== '') {
      obj.matchId = message.matchId;
    }
    if (message.matchData !== undefined) {
      obj.matchData = MatchData.toJSON(message.matchData);
    }
    if (message.oddsData !== undefined) {
      obj.oddsData = OddsDataList.toJSON(message.oddsData);
    }
    if (message.leftSportCountData !== undefined) {
      obj.leftSportCountData = LeftSportCountData.toJSON(message.leftSportCountData);
    }
    if (message.topSportCountData !== undefined) {
      obj.topSportCountData = TopSportCountData.toJSON(message.topSportCountData);
    }
    if (message.oddsRecommendData !== undefined) {
      obj.oddsRecommendData = OddsRecommendData.toJSON(message.oddsRecommendData);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MessageContent>, I>>(base?: I): MessageContent {
    return MessageContent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MessageContent>, I>>(object: I): MessageContent {
    const message = createBaseMessageContent();
    message.type = object.type ?? '';
    message.matchId = object.matchId ?? '';
    message.matchData =
      object.matchData !== undefined && object.matchData !== null ? MatchData.fromPartial(object.matchData) : undefined;
    message.oddsData =
      object.oddsData !== undefined && object.oddsData !== null ? OddsDataList.fromPartial(object.oddsData) : undefined;
    message.leftSportCountData =
      object.leftSportCountData !== undefined && object.leftSportCountData !== null
        ? LeftSportCountData.fromPartial(object.leftSportCountData)
        : undefined;
    message.topSportCountData =
      object.topSportCountData !== undefined && object.topSportCountData !== null
        ? TopSportCountData.fromPartial(object.topSportCountData)
        : undefined;
    message.oddsRecommendData =
      object.oddsRecommendData !== undefined && object.oddsRecommendData !== null
        ? OddsRecommendData.fromPartial(object.oddsRecommendData)
        : undefined;
    return message;
  },
};

function createBaseLeftSportCountData(): LeftSportCountData {
  return {
    sportCount: 0,
    sportId: '',
    sportName: '',
    tournamentCount: 0,
    tournamentId: '',
    tournamentName: '',
    type: '',
    timestamp: 0,
    categoryCount: 0,
    categoryId: '',
  };
}

export const LeftSportCountData: MessageFns<LeftSportCountData> = {
  encode(message: LeftSportCountData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sportCount !== 0) {
      writer.uint32(8).int32(message.sportCount);
    }
    if (message.sportId !== '') {
      writer.uint32(18).string(message.sportId);
    }
    if (message.sportName !== '') {
      writer.uint32(26).string(message.sportName);
    }
    if (message.tournamentCount !== 0) {
      writer.uint32(32).int32(message.tournamentCount);
    }
    if (message.tournamentId !== '') {
      writer.uint32(42).string(message.tournamentId);
    }
    if (message.tournamentName !== '') {
      writer.uint32(50).string(message.tournamentName);
    }
    if (message.type !== '') {
      writer.uint32(58).string(message.type);
    }
    if (message.timestamp !== 0) {
      writer.uint32(64).int64(message.timestamp);
    }
    if (message.categoryCount !== 0) {
      writer.uint32(72).int32(message.categoryCount);
    }
    if (message.categoryId !== '') {
      writer.uint32(82).string(message.categoryId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LeftSportCountData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLeftSportCountData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.sportCount = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.sportId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sportName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.tournamentCount = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.tournamentId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.tournamentName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.timestamp = longToNumber(reader.int64());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.categoryCount = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.categoryId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LeftSportCountData {
    return {
      sportCount: isSet(object.sportCount) ? globalThis.Number(object.sportCount) : 0,
      sportId: isSet(object.sportId) ? globalThis.String(object.sportId) : '',
      sportName: isSet(object.sportName) ? globalThis.String(object.sportName) : '',
      tournamentCount: isSet(object.tournamentCount) ? globalThis.Number(object.tournamentCount) : 0,
      tournamentId: isSet(object.tournamentId) ? globalThis.String(object.tournamentId) : '',
      tournamentName: isSet(object.tournamentName) ? globalThis.String(object.tournamentName) : '',
      type: isSet(object.type) ? globalThis.String(object.type) : '',
      timestamp: isSet(object.timestamp) ? globalThis.Number(object.timestamp) : 0,
      categoryCount: isSet(object.categoryCount) ? globalThis.Number(object.categoryCount) : 0,
      categoryId: isSet(object.categoryId) ? globalThis.String(object.categoryId) : '',
    };
  },

  toJSON(message: LeftSportCountData): unknown {
    const obj: any = {};
    if (message.sportCount !== 0) {
      obj.sportCount = Math.round(message.sportCount);
    }
    if (message.sportId !== '') {
      obj.sportId = message.sportId;
    }
    if (message.sportName !== '') {
      obj.sportName = message.sportName;
    }
    if (message.tournamentCount !== 0) {
      obj.tournamentCount = Math.round(message.tournamentCount);
    }
    if (message.tournamentId !== '') {
      obj.tournamentId = message.tournamentId;
    }
    if (message.tournamentName !== '') {
      obj.tournamentName = message.tournamentName;
    }
    if (message.type !== '') {
      obj.type = message.type;
    }
    if (message.timestamp !== 0) {
      obj.timestamp = Math.round(message.timestamp);
    }
    if (message.categoryCount !== 0) {
      obj.categoryCount = Math.round(message.categoryCount);
    }
    if (message.categoryId !== '') {
      obj.categoryId = message.categoryId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LeftSportCountData>, I>>(base?: I): LeftSportCountData {
    return LeftSportCountData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LeftSportCountData>, I>>(object: I): LeftSportCountData {
    const message = createBaseLeftSportCountData();
    message.sportCount = object.sportCount ?? 0;
    message.sportId = object.sportId ?? '';
    message.sportName = object.sportName ?? '';
    message.tournamentCount = object.tournamentCount ?? 0;
    message.tournamentId = object.tournamentId ?? '';
    message.tournamentName = object.tournamentName ?? '';
    message.type = object.type ?? '';
    message.timestamp = object.timestamp ?? 0;
    message.categoryCount = object.categoryCount ?? 0;
    message.categoryId = object.categoryId ?? '';
    return message;
  },
};

function createBaseTopSportCountData(): TopSportCountData {
  return {
    liveSportCount: 0,
    liveSportId: '',
    liveSportName: '',
    upComingSportCount: 0,
    upComingSportId: '',
    upComingSportName: '',
    sort: 0,
    timestamp: 0,
  };
}

export const TopSportCountData: MessageFns<TopSportCountData> = {
  encode(message: TopSportCountData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.liveSportCount !== 0) {
      writer.uint32(8).int32(message.liveSportCount);
    }
    if (message.liveSportId !== '') {
      writer.uint32(18).string(message.liveSportId);
    }
    if (message.liveSportName !== '') {
      writer.uint32(26).string(message.liveSportName);
    }
    if (message.upComingSportCount !== 0) {
      writer.uint32(32).int32(message.upComingSportCount);
    }
    if (message.upComingSportId !== '') {
      writer.uint32(42).string(message.upComingSportId);
    }
    if (message.upComingSportName !== '') {
      writer.uint32(50).string(message.upComingSportName);
    }
    if (message.sort !== 0) {
      writer.uint32(56).int32(message.sort);
    }
    if (message.timestamp !== 0) {
      writer.uint32(64).int64(message.timestamp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TopSportCountData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTopSportCountData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.liveSportCount = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.liveSportId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.liveSportName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.upComingSportCount = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.upComingSportId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.upComingSportName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.sort = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.timestamp = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TopSportCountData {
    return {
      liveSportCount: isSet(object.liveSportCount) ? globalThis.Number(object.liveSportCount) : 0,
      liveSportId: isSet(object.liveSportId) ? globalThis.String(object.liveSportId) : '',
      liveSportName: isSet(object.liveSportName) ? globalThis.String(object.liveSportName) : '',
      upComingSportCount: isSet(object.upComingSportCount) ? globalThis.Number(object.upComingSportCount) : 0,
      upComingSportId: isSet(object.upComingSportId) ? globalThis.String(object.upComingSportId) : '',
      upComingSportName: isSet(object.upComingSportName) ? globalThis.String(object.upComingSportName) : '',
      sort: isSet(object.sort) ? globalThis.Number(object.sort) : 0,
      timestamp: isSet(object.timestamp) ? globalThis.Number(object.timestamp) : 0,
    };
  },

  toJSON(message: TopSportCountData): unknown {
    const obj: any = {};
    if (message.liveSportCount !== 0) {
      obj.liveSportCount = Math.round(message.liveSportCount);
    }
    if (message.liveSportId !== '') {
      obj.liveSportId = message.liveSportId;
    }
    if (message.liveSportName !== '') {
      obj.liveSportName = message.liveSportName;
    }
    if (message.upComingSportCount !== 0) {
      obj.upComingSportCount = Math.round(message.upComingSportCount);
    }
    if (message.upComingSportId !== '') {
      obj.upComingSportId = message.upComingSportId;
    }
    if (message.upComingSportName !== '') {
      obj.upComingSportName = message.upComingSportName;
    }
    if (message.sort !== 0) {
      obj.sort = Math.round(message.sort);
    }
    if (message.timestamp !== 0) {
      obj.timestamp = Math.round(message.timestamp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TopSportCountData>, I>>(base?: I): TopSportCountData {
    return TopSportCountData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TopSportCountData>, I>>(object: I): TopSportCountData {
    const message = createBaseTopSportCountData();
    message.liveSportCount = object.liveSportCount ?? 0;
    message.liveSportId = object.liveSportId ?? '';
    message.liveSportName = object.liveSportName ?? '';
    message.upComingSportCount = object.upComingSportCount ?? 0;
    message.upComingSportId = object.upComingSportId ?? '';
    message.upComingSportName = object.upComingSportName ?? '';
    message.sort = object.sort ?? 0;
    message.timestamp = object.timestamp ?? 0;
    return message;
  },
};

function createBaseMatchData(): MatchData {
  return {
    id: '',
    seasonId: '',
    seasonName: '',
    seasonYear: '',
    name: '',
    homeId: '',
    homeName: '',
    homeLogoUrl: '',
    homeJersey: '',
    awayId: '',
    awayName: '',
    awayLogoUrl: '',
    awayJersey: '',
    venueId: '',
    venueName: '',
    refereeId: '',
    refereeName: '',
    type: '',
    groupId: '',
    groupName: '',
    phase: '',
    otherMatchId: '',
    tournamentRound: '',
    scheduledTime: 0,
    scheduledEndTime: undefined,
    matchTime: '',
    status: 0,
    statusName: '',
    homeScore: 0,
    awayScore: 0,
    homePenaltyScore: 0,
    awayPenaltyScore: 0,
    stoppageTime: '',
    stoppageTimeAnnounced: '',
    remainingTime: '',
    remainingTimeInPeriod: '',
    stopped: false,
    reporting: 0,
    matchStatus: 0,
    matchStatusName: '',
    winnerId: '',
    periodScores: [],
    sportEventStatus: undefined,
  };
}

export const MatchData: MessageFns<MatchData> = {
  encode(message: MatchData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== '') {
      writer.uint32(10).string(message.id);
    }
    if (message.seasonId !== '') {
      writer.uint32(18).string(message.seasonId);
    }
    if (message.seasonName !== '') {
      writer.uint32(26).string(message.seasonName);
    }
    if (message.seasonYear !== '') {
      writer.uint32(34).string(message.seasonYear);
    }
    if (message.name !== '') {
      writer.uint32(42).string(message.name);
    }
    if (message.homeId !== '') {
      writer.uint32(50).string(message.homeId);
    }
    if (message.homeName !== '') {
      writer.uint32(58).string(message.homeName);
    }
    if (message.homeLogoUrl !== '') {
      writer.uint32(66).string(message.homeLogoUrl);
    }
    if (message.homeJersey !== '') {
      writer.uint32(74).string(message.homeJersey);
    }
    if (message.awayId !== '') {
      writer.uint32(82).string(message.awayId);
    }
    if (message.awayName !== '') {
      writer.uint32(90).string(message.awayName);
    }
    if (message.awayLogoUrl !== '') {
      writer.uint32(98).string(message.awayLogoUrl);
    }
    if (message.awayJersey !== '') {
      writer.uint32(106).string(message.awayJersey);
    }
    if (message.venueId !== '') {
      writer.uint32(114).string(message.venueId);
    }
    if (message.venueName !== '') {
      writer.uint32(122).string(message.venueName);
    }
    if (message.refereeId !== '') {
      writer.uint32(130).string(message.refereeId);
    }
    if (message.refereeName !== '') {
      writer.uint32(138).string(message.refereeName);
    }
    if (message.type !== '') {
      writer.uint32(146).string(message.type);
    }
    if (message.groupId !== '') {
      writer.uint32(154).string(message.groupId);
    }
    if (message.groupName !== '') {
      writer.uint32(162).string(message.groupName);
    }
    if (message.phase !== '') {
      writer.uint32(170).string(message.phase);
    }
    if (message.otherMatchId !== '') {
      writer.uint32(178).string(message.otherMatchId);
    }
    if (message.tournamentRound !== '') {
      writer.uint32(186).string(message.tournamentRound);
    }
    if (message.scheduledTime !== 0) {
      writer.uint32(192).int64(message.scheduledTime);
    }
    if (message.scheduledEndTime !== undefined) {
      writer.uint32(200).int64(message.scheduledEndTime);
    }
    if (message.matchTime !== '') {
      writer.uint32(210).string(message.matchTime);
    }
    if (message.status !== 0) {
      writer.uint32(216).int32(message.status);
    }
    if (message.statusName !== '') {
      writer.uint32(226).string(message.statusName);
    }
    if (message.homeScore !== 0) {
      writer.uint32(232).int32(message.homeScore);
    }
    if (message.awayScore !== 0) {
      writer.uint32(240).int32(message.awayScore);
    }
    if (message.homePenaltyScore !== 0) {
      writer.uint32(248).int32(message.homePenaltyScore);
    }
    if (message.awayPenaltyScore !== 0) {
      writer.uint32(256).int32(message.awayPenaltyScore);
    }
    if (message.stoppageTime !== '') {
      writer.uint32(266).string(message.stoppageTime);
    }
    if (message.stoppageTimeAnnounced !== '') {
      writer.uint32(274).string(message.stoppageTimeAnnounced);
    }
    if (message.remainingTime !== '') {
      writer.uint32(282).string(message.remainingTime);
    }
    if (message.remainingTimeInPeriod !== '') {
      writer.uint32(290).string(message.remainingTimeInPeriod);
    }
    if (message.stopped !== false) {
      writer.uint32(296).bool(message.stopped);
    }
    if (message.reporting !== 0) {
      writer.uint32(304).int32(message.reporting);
    }
    if (message.matchStatus !== 0) {
      writer.uint32(312).int32(message.matchStatus);
    }
    if (message.matchStatusName !== '') {
      writer.uint32(322).string(message.matchStatusName);
    }
    if (message.winnerId !== '') {
      writer.uint32(330).string(message.winnerId);
    }
    for (const v of message.periodScores) {
      MatchPeriodScoreDto.encode(v!, writer.uint32(338).fork()).join();
    }
    if (message.sportEventStatus !== undefined) {
      SportEventStatusDto.encode(message.sportEventStatus, writer.uint32(346).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MatchData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMatchData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.seasonId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.seasonName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.seasonYear = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.homeId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.homeName = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.homeLogoUrl = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.homeJersey = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.awayId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.awayName = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.awayLogoUrl = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.awayJersey = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.venueId = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.venueName = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.refereeId = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.refereeName = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.groupName = reader.string();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.phase = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.otherMatchId = reader.string();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.tournamentRound = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.scheduledTime = longToNumber(reader.int64());
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.scheduledEndTime = longToNumber(reader.int64());
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.matchTime = reader.string();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.status = reader.int32();
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.statusName = reader.string();
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.homeScore = reader.int32();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.awayScore = reader.int32();
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.homePenaltyScore = reader.int32();
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.awayPenaltyScore = reader.int32();
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.stoppageTime = reader.string();
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.stoppageTimeAnnounced = reader.string();
          continue;
        }
        case 35: {
          if (tag !== 282) {
            break;
          }

          message.remainingTime = reader.string();
          continue;
        }
        case 36: {
          if (tag !== 290) {
            break;
          }

          message.remainingTimeInPeriod = reader.string();
          continue;
        }
        case 37: {
          if (tag !== 296) {
            break;
          }

          message.stopped = reader.bool();
          continue;
        }
        case 38: {
          if (tag !== 304) {
            break;
          }

          message.reporting = reader.int32();
          continue;
        }
        case 39: {
          if (tag !== 312) {
            break;
          }

          message.matchStatus = reader.int32();
          continue;
        }
        case 40: {
          if (tag !== 322) {
            break;
          }

          message.matchStatusName = reader.string();
          continue;
        }
        case 41: {
          if (tag !== 330) {
            break;
          }

          message.winnerId = reader.string();
          continue;
        }
        case 42: {
          if (tag !== 338) {
            break;
          }

          message.periodScores.push(MatchPeriodScoreDto.decode(reader, reader.uint32()));
          continue;
        }
        case 43: {
          if (tag !== 346) {
            break;
          }

          message.sportEventStatus = SportEventStatusDto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MatchData {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : '',
      seasonId: isSet(object.seasonId) ? globalThis.String(object.seasonId) : '',
      seasonName: isSet(object.seasonName) ? globalThis.String(object.seasonName) : '',
      seasonYear: isSet(object.seasonYear) ? globalThis.String(object.seasonYear) : '',
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      homeId: isSet(object.homeId) ? globalThis.String(object.homeId) : '',
      homeName: isSet(object.homeName) ? globalThis.String(object.homeName) : '',
      homeLogoUrl: isSet(object.homeLogoUrl) ? globalThis.String(object.homeLogoUrl) : '',
      homeJersey: isSet(object.homeJersey) ? globalThis.String(object.homeJersey) : '',
      awayId: isSet(object.awayId) ? globalThis.String(object.awayId) : '',
      awayName: isSet(object.awayName) ? globalThis.String(object.awayName) : '',
      awayLogoUrl: isSet(object.awayLogoUrl) ? globalThis.String(object.awayLogoUrl) : '',
      awayJersey: isSet(object.awayJersey) ? globalThis.String(object.awayJersey) : '',
      venueId: isSet(object.venueId) ? globalThis.String(object.venueId) : '',
      venueName: isSet(object.venueName) ? globalThis.String(object.venueName) : '',
      refereeId: isSet(object.refereeId) ? globalThis.String(object.refereeId) : '',
      refereeName: isSet(object.refereeName) ? globalThis.String(object.refereeName) : '',
      type: isSet(object.type) ? globalThis.String(object.type) : '',
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : '',
      groupName: isSet(object.groupName) ? globalThis.String(object.groupName) : '',
      phase: isSet(object.phase) ? globalThis.String(object.phase) : '',
      otherMatchId: isSet(object.otherMatchId) ? globalThis.String(object.otherMatchId) : '',
      tournamentRound: isSet(object.tournamentRound) ? globalThis.String(object.tournamentRound) : '',
      scheduledTime: isSet(object.scheduledTime) ? globalThis.Number(object.scheduledTime) : 0,
      scheduledEndTime: isSet(object.scheduledEndTime) ? globalThis.Number(object.scheduledEndTime) : undefined,
      matchTime: isSet(object.matchTime) ? globalThis.String(object.matchTime) : '',
      status: isSet(object.status) ? globalThis.Number(object.status) : 0,
      statusName: isSet(object.statusName) ? globalThis.String(object.statusName) : '',
      homeScore: isSet(object.homeScore) ? globalThis.Number(object.homeScore) : 0,
      awayScore: isSet(object.awayScore) ? globalThis.Number(object.awayScore) : 0,
      homePenaltyScore: isSet(object.homePenaltyScore) ? globalThis.Number(object.homePenaltyScore) : 0,
      awayPenaltyScore: isSet(object.awayPenaltyScore) ? globalThis.Number(object.awayPenaltyScore) : 0,
      stoppageTime: isSet(object.stoppageTime) ? globalThis.String(object.stoppageTime) : '',
      stoppageTimeAnnounced: isSet(object.stoppageTimeAnnounced) ? globalThis.String(object.stoppageTimeAnnounced) : '',
      remainingTime: isSet(object.remainingTime) ? globalThis.String(object.remainingTime) : '',
      remainingTimeInPeriod: isSet(object.remainingTimeInPeriod) ? globalThis.String(object.remainingTimeInPeriod) : '',
      stopped: isSet(object.stopped) ? globalThis.Boolean(object.stopped) : false,
      reporting: isSet(object.reporting) ? globalThis.Number(object.reporting) : 0,
      matchStatus: isSet(object.matchStatus) ? globalThis.Number(object.matchStatus) : 0,
      matchStatusName: isSet(object.matchStatusName) ? globalThis.String(object.matchStatusName) : '',
      winnerId: isSet(object.winnerId) ? globalThis.String(object.winnerId) : '',
      periodScores: globalThis.Array.isArray(object?.periodScores)
        ? object.periodScores.map((e: any) => MatchPeriodScoreDto.fromJSON(e))
        : [],
      sportEventStatus: isSet(object.sportEventStatus)
        ? SportEventStatusDto.fromJSON(object.sportEventStatus)
        : undefined,
    };
  },

  toJSON(message: MatchData): unknown {
    const obj: any = {};
    if (message.id !== '') {
      obj.id = message.id;
    }
    if (message.seasonId !== '') {
      obj.seasonId = message.seasonId;
    }
    if (message.seasonName !== '') {
      obj.seasonName = message.seasonName;
    }
    if (message.seasonYear !== '') {
      obj.seasonYear = message.seasonYear;
    }
    if (message.name !== '') {
      obj.name = message.name;
    }
    if (message.homeId !== '') {
      obj.homeId = message.homeId;
    }
    if (message.homeName !== '') {
      obj.homeName = message.homeName;
    }
    if (message.homeLogoUrl !== '') {
      obj.homeLogoUrl = message.homeLogoUrl;
    }
    if (message.homeJersey !== '') {
      obj.homeJersey = message.homeJersey;
    }
    if (message.awayId !== '') {
      obj.awayId = message.awayId;
    }
    if (message.awayName !== '') {
      obj.awayName = message.awayName;
    }
    if (message.awayLogoUrl !== '') {
      obj.awayLogoUrl = message.awayLogoUrl;
    }
    if (message.awayJersey !== '') {
      obj.awayJersey = message.awayJersey;
    }
    if (message.venueId !== '') {
      obj.venueId = message.venueId;
    }
    if (message.venueName !== '') {
      obj.venueName = message.venueName;
    }
    if (message.refereeId !== '') {
      obj.refereeId = message.refereeId;
    }
    if (message.refereeName !== '') {
      obj.refereeName = message.refereeName;
    }
    if (message.type !== '') {
      obj.type = message.type;
    }
    if (message.groupId !== '') {
      obj.groupId = message.groupId;
    }
    if (message.groupName !== '') {
      obj.groupName = message.groupName;
    }
    if (message.phase !== '') {
      obj.phase = message.phase;
    }
    if (message.otherMatchId !== '') {
      obj.otherMatchId = message.otherMatchId;
    }
    if (message.tournamentRound !== '') {
      obj.tournamentRound = message.tournamentRound;
    }
    if (message.scheduledTime !== 0) {
      obj.scheduledTime = Math.round(message.scheduledTime);
    }
    if (message.scheduledEndTime !== undefined) {
      obj.scheduledEndTime = Math.round(message.scheduledEndTime);
    }
    if (message.matchTime !== '') {
      obj.matchTime = message.matchTime;
    }
    if (message.status !== 0) {
      obj.status = Math.round(message.status);
    }
    if (message.statusName !== '') {
      obj.statusName = message.statusName;
    }
    if (message.homeScore !== 0) {
      obj.homeScore = Math.round(message.homeScore);
    }
    if (message.awayScore !== 0) {
      obj.awayScore = Math.round(message.awayScore);
    }
    if (message.homePenaltyScore !== 0) {
      obj.homePenaltyScore = Math.round(message.homePenaltyScore);
    }
    if (message.awayPenaltyScore !== 0) {
      obj.awayPenaltyScore = Math.round(message.awayPenaltyScore);
    }
    if (message.stoppageTime !== '') {
      obj.stoppageTime = message.stoppageTime;
    }
    if (message.stoppageTimeAnnounced !== '') {
      obj.stoppageTimeAnnounced = message.stoppageTimeAnnounced;
    }
    if (message.remainingTime !== '') {
      obj.remainingTime = message.remainingTime;
    }
    if (message.remainingTimeInPeriod !== '') {
      obj.remainingTimeInPeriod = message.remainingTimeInPeriod;
    }
    if (message.stopped !== false) {
      obj.stopped = message.stopped;
    }
    if (message.reporting !== 0) {
      obj.reporting = Math.round(message.reporting);
    }
    if (message.matchStatus !== 0) {
      obj.matchStatus = Math.round(message.matchStatus);
    }
    if (message.matchStatusName !== '') {
      obj.matchStatusName = message.matchStatusName;
    }
    if (message.winnerId !== '') {
      obj.winnerId = message.winnerId;
    }
    if (message.periodScores?.length) {
      obj.periodScores = message.periodScores.map((e) => MatchPeriodScoreDto.toJSON(e));
    }
    if (message.sportEventStatus !== undefined) {
      obj.sportEventStatus = SportEventStatusDto.toJSON(message.sportEventStatus);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MatchData>, I>>(base?: I): MatchData {
    return MatchData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MatchData>, I>>(object: I): MatchData {
    const message = createBaseMatchData();
    message.id = object.id ?? '';
    message.seasonId = object.seasonId ?? '';
    message.seasonName = object.seasonName ?? '';
    message.seasonYear = object.seasonYear ?? '';
    message.name = object.name ?? '';
    message.homeId = object.homeId ?? '';
    message.homeName = object.homeName ?? '';
    message.homeLogoUrl = object.homeLogoUrl ?? '';
    message.homeJersey = object.homeJersey ?? '';
    message.awayId = object.awayId ?? '';
    message.awayName = object.awayName ?? '';
    message.awayLogoUrl = object.awayLogoUrl ?? '';
    message.awayJersey = object.awayJersey ?? '';
    message.venueId = object.venueId ?? '';
    message.venueName = object.venueName ?? '';
    message.refereeId = object.refereeId ?? '';
    message.refereeName = object.refereeName ?? '';
    message.type = object.type ?? '';
    message.groupId = object.groupId ?? '';
    message.groupName = object.groupName ?? '';
    message.phase = object.phase ?? '';
    message.otherMatchId = object.otherMatchId ?? '';
    message.tournamentRound = object.tournamentRound ?? '';
    message.scheduledTime = object.scheduledTime ?? 0;
    message.scheduledEndTime = object.scheduledEndTime ?? undefined;
    message.matchTime = object.matchTime ?? '';
    message.status = object.status ?? 0;
    message.statusName = object.statusName ?? '';
    message.homeScore = object.homeScore ?? 0;
    message.awayScore = object.awayScore ?? 0;
    message.homePenaltyScore = object.homePenaltyScore ?? 0;
    message.awayPenaltyScore = object.awayPenaltyScore ?? 0;
    message.stoppageTime = object.stoppageTime ?? '';
    message.stoppageTimeAnnounced = object.stoppageTimeAnnounced ?? '';
    message.remainingTime = object.remainingTime ?? '';
    message.remainingTimeInPeriod = object.remainingTimeInPeriod ?? '';
    message.stopped = object.stopped ?? false;
    message.reporting = object.reporting ?? 0;
    message.matchStatus = object.matchStatus ?? 0;
    message.matchStatusName = object.matchStatusName ?? '';
    message.winnerId = object.winnerId ?? '';
    message.periodScores = object.periodScores?.map((e) => MatchPeriodScoreDto.fromPartial(e)) || [];
    message.sportEventStatus =
      object.sportEventStatus !== undefined && object.sportEventStatus !== null
        ? SportEventStatusDto.fromPartial(object.sportEventStatus)
        : undefined;
    return message;
  },
};

function createBaseMatchPeriodScoreDto(): MatchPeriodScoreDto {
  return { homeScore: 0, awayScore: 0, matchStatusCode: 0, number: 0 };
}

export const MatchPeriodScoreDto: MessageFns<MatchPeriodScoreDto> = {
  encode(message: MatchPeriodScoreDto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.homeScore !== 0) {
      writer.uint32(8).int32(message.homeScore);
    }
    if (message.awayScore !== 0) {
      writer.uint32(16).int32(message.awayScore);
    }
    if (message.matchStatusCode !== 0) {
      writer.uint32(24).int32(message.matchStatusCode);
    }
    if (message.number !== 0) {
      writer.uint32(32).int32(message.number);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MatchPeriodScoreDto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMatchPeriodScoreDto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.homeScore = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.awayScore = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.matchStatusCode = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.number = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MatchPeriodScoreDto {
    return {
      homeScore: isSet(object.homeScore) ? globalThis.Number(object.homeScore) : 0,
      awayScore: isSet(object.awayScore) ? globalThis.Number(object.awayScore) : 0,
      matchStatusCode: isSet(object.matchStatusCode) ? globalThis.Number(object.matchStatusCode) : 0,
      number: isSet(object.number) ? globalThis.Number(object.number) : 0,
    };
  },

  toJSON(message: MatchPeriodScoreDto): unknown {
    const obj: any = {};
    if (message.homeScore !== 0) {
      obj.homeScore = Math.round(message.homeScore);
    }
    if (message.awayScore !== 0) {
      obj.awayScore = Math.round(message.awayScore);
    }
    if (message.matchStatusCode !== 0) {
      obj.matchStatusCode = Math.round(message.matchStatusCode);
    }
    if (message.number !== 0) {
      obj.number = Math.round(message.number);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MatchPeriodScoreDto>, I>>(base?: I): MatchPeriodScoreDto {
    return MatchPeriodScoreDto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MatchPeriodScoreDto>, I>>(object: I): MatchPeriodScoreDto {
    const message = createBaseMatchPeriodScoreDto();
    message.homeScore = object.homeScore ?? 0;
    message.awayScore = object.awayScore ?? 0;
    message.matchStatusCode = object.matchStatusCode ?? 0;
    message.number = object.number ?? 0;
    return message;
  },
};

function createBaseEventClockDto(): EventClockDto {
  return {
    matchTime: '',
    stoppageTime: '',
    stoppageTimeAnnounced: '',
    remainingTime: '',
    remainingTimeInPeriod: '',
    stopped: false,
  };
}

export const EventClockDto: MessageFns<EventClockDto> = {
  encode(message: EventClockDto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.matchTime !== '') {
      writer.uint32(10).string(message.matchTime);
    }
    if (message.stoppageTime !== '') {
      writer.uint32(18).string(message.stoppageTime);
    }
    if (message.stoppageTimeAnnounced !== '') {
      writer.uint32(26).string(message.stoppageTimeAnnounced);
    }
    if (message.remainingTime !== '') {
      writer.uint32(34).string(message.remainingTime);
    }
    if (message.remainingTimeInPeriod !== '') {
      writer.uint32(42).string(message.remainingTimeInPeriod);
    }
    if (message.stopped !== false) {
      writer.uint32(48).bool(message.stopped);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EventClockDto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEventClockDto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.matchTime = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stoppageTime = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.stoppageTimeAnnounced = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.remainingTime = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.remainingTimeInPeriod = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.stopped = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EventClockDto {
    return {
      matchTime: isSet(object.matchTime) ? globalThis.String(object.matchTime) : '',
      stoppageTime: isSet(object.stoppageTime) ? globalThis.String(object.stoppageTime) : '',
      stoppageTimeAnnounced: isSet(object.stoppageTimeAnnounced) ? globalThis.String(object.stoppageTimeAnnounced) : '',
      remainingTime: isSet(object.remainingTime) ? globalThis.String(object.remainingTime) : '',
      remainingTimeInPeriod: isSet(object.remainingTimeInPeriod) ? globalThis.String(object.remainingTimeInPeriod) : '',
      stopped: isSet(object.stopped) ? globalThis.Boolean(object.stopped) : false,
    };
  },

  toJSON(message: EventClockDto): unknown {
    const obj: any = {};
    if (message.matchTime !== '') {
      obj.matchTime = message.matchTime;
    }
    if (message.stoppageTime !== '') {
      obj.stoppageTime = message.stoppageTime;
    }
    if (message.stoppageTimeAnnounced !== '') {
      obj.stoppageTimeAnnounced = message.stoppageTimeAnnounced;
    }
    if (message.remainingTime !== '') {
      obj.remainingTime = message.remainingTime;
    }
    if (message.remainingTimeInPeriod !== '') {
      obj.remainingTimeInPeriod = message.remainingTimeInPeriod;
    }
    if (message.stopped !== false) {
      obj.stopped = message.stopped;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EventClockDto>, I>>(base?: I): EventClockDto {
    return EventClockDto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EventClockDto>, I>>(object: I): EventClockDto {
    const message = createBaseEventClockDto();
    message.matchTime = object.matchTime ?? '';
    message.stoppageTime = object.stoppageTime ?? '';
    message.stoppageTimeAnnounced = object.stoppageTimeAnnounced ?? '';
    message.remainingTime = object.remainingTime ?? '';
    message.remainingTimeInPeriod = object.remainingTimeInPeriod ?? '';
    message.stopped = object.stopped ?? false;
    return message;
  },
};

function createBaseSportEventStatusDto(): SportEventStatusDto {
  return {
    clock: undefined,
    periodScores: [],
    status: 0,
    statusName: '',
    matchStatus: 0,
    matchStatusName: '',
    homeScore: 0,
    awayScore: 0,
    homePenaltyScore: 0,
    awayPenaltyScore: 0,
    homeGamescore: 0,
    awayGamescore: 0,
    homeLegscore: 0,
    awayLegscore: 0,
    currentServer: 0,
    expediteMode: false,
    tiebreak: false,
    homeSuspend: 0,
    awaySuspend: 0,
    balls: 0,
    strikes: 0,
    outs: 0,
    bases: '',
    homeBatter: 0,
    awayBatter: 0,
    pitcher: '',
    batter: '',
    pitchCount: 0,
    pitchesSeen: 0,
    totalHits: 0,
    totalPitches: 0,
    possession: 0,
    position: 0,
    getTry: 0,
    yards: 0,
    getThrow: 0,
    visit: 0,
    remainingReds: 0,
    delivery: 0,
    homeRemainingBowls: 0,
    awayRemainingBowls: 0,
    currentEnd: 0,
    innings: 0,
    over: 0,
    homePenaltyRuns: 0,
    awayPenaltyRuns: 0,
    homeDismissals: 0,
    awayDismissals: 0,
    currentCtTeam: 0,
    periodOfLeader: 0,
    homeDriveCount: 0,
    awayDriveCount: 0,
    homePlayCount: 0,
    awayPlayCount: 0,
  };
}

export const SportEventStatusDto: MessageFns<SportEventStatusDto> = {
  encode(message: SportEventStatusDto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.clock !== undefined) {
      EventClockDto.encode(message.clock, writer.uint32(10).fork()).join();
    }
    for (const v of message.periodScores) {
      MatchPeriodScoreDto.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(24).int32(message.status);
    }
    if (message.statusName !== '') {
      writer.uint32(34).string(message.statusName);
    }
    if (message.matchStatus !== 0) {
      writer.uint32(40).int32(message.matchStatus);
    }
    if (message.matchStatusName !== '') {
      writer.uint32(50).string(message.matchStatusName);
    }
    if (message.homeScore !== 0) {
      writer.uint32(56).int32(message.homeScore);
    }
    if (message.awayScore !== 0) {
      writer.uint32(64).int32(message.awayScore);
    }
    if (message.homePenaltyScore !== 0) {
      writer.uint32(72).int32(message.homePenaltyScore);
    }
    if (message.awayPenaltyScore !== 0) {
      writer.uint32(80).int32(message.awayPenaltyScore);
    }
    if (message.homeGamescore !== 0) {
      writer.uint32(88).int32(message.homeGamescore);
    }
    if (message.awayGamescore !== 0) {
      writer.uint32(96).int32(message.awayGamescore);
    }
    if (message.homeLegscore !== 0) {
      writer.uint32(104).int32(message.homeLegscore);
    }
    if (message.awayLegscore !== 0) {
      writer.uint32(112).int32(message.awayLegscore);
    }
    if (message.currentServer !== 0) {
      writer.uint32(120).int32(message.currentServer);
    }
    if (message.expediteMode !== false) {
      writer.uint32(128).bool(message.expediteMode);
    }
    if (message.tiebreak !== false) {
      writer.uint32(136).bool(message.tiebreak);
    }
    if (message.homeSuspend !== 0) {
      writer.uint32(144).int32(message.homeSuspend);
    }
    if (message.awaySuspend !== 0) {
      writer.uint32(152).int32(message.awaySuspend);
    }
    if (message.balls !== 0) {
      writer.uint32(160).int32(message.balls);
    }
    if (message.strikes !== 0) {
      writer.uint32(168).int32(message.strikes);
    }
    if (message.outs !== 0) {
      writer.uint32(176).int32(message.outs);
    }
    if (message.bases !== '') {
      writer.uint32(186).string(message.bases);
    }
    if (message.homeBatter !== 0) {
      writer.uint32(192).int32(message.homeBatter);
    }
    if (message.awayBatter !== 0) {
      writer.uint32(200).int32(message.awayBatter);
    }
    if (message.pitcher !== '') {
      writer.uint32(210).string(message.pitcher);
    }
    if (message.batter !== '') {
      writer.uint32(218).string(message.batter);
    }
    if (message.pitchCount !== 0) {
      writer.uint32(224).int32(message.pitchCount);
    }
    if (message.pitchesSeen !== 0) {
      writer.uint32(232).int32(message.pitchesSeen);
    }
    if (message.totalHits !== 0) {
      writer.uint32(240).int32(message.totalHits);
    }
    if (message.totalPitches !== 0) {
      writer.uint32(248).int32(message.totalPitches);
    }
    if (message.possession !== 0) {
      writer.uint32(256).int32(message.possession);
    }
    if (message.position !== 0) {
      writer.uint32(264).int32(message.position);
    }
    if (message.getTry !== 0) {
      writer.uint32(272).int32(message.getTry);
    }
    if (message.yards !== 0) {
      writer.uint32(280).int32(message.yards);
    }
    if (message.getThrow !== 0) {
      writer.uint32(288).int32(message.getThrow);
    }
    if (message.visit !== 0) {
      writer.uint32(296).int32(message.visit);
    }
    if (message.remainingReds !== 0) {
      writer.uint32(304).int32(message.remainingReds);
    }
    if (message.delivery !== 0) {
      writer.uint32(312).int32(message.delivery);
    }
    if (message.homeRemainingBowls !== 0) {
      writer.uint32(320).int32(message.homeRemainingBowls);
    }
    if (message.awayRemainingBowls !== 0) {
      writer.uint32(328).int32(message.awayRemainingBowls);
    }
    if (message.currentEnd !== 0) {
      writer.uint32(336).int32(message.currentEnd);
    }
    if (message.innings !== 0) {
      writer.uint32(344).int32(message.innings);
    }
    if (message.over !== 0) {
      writer.uint32(352).int32(message.over);
    }
    if (message.homePenaltyRuns !== 0) {
      writer.uint32(360).int32(message.homePenaltyRuns);
    }
    if (message.awayPenaltyRuns !== 0) {
      writer.uint32(368).int32(message.awayPenaltyRuns);
    }
    if (message.homeDismissals !== 0) {
      writer.uint32(376).int32(message.homeDismissals);
    }
    if (message.awayDismissals !== 0) {
      writer.uint32(384).int32(message.awayDismissals);
    }
    if (message.currentCtTeam !== 0) {
      writer.uint32(392).int32(message.currentCtTeam);
    }
    if (message.periodOfLeader !== 0) {
      writer.uint32(400).int32(message.periodOfLeader);
    }
    if (message.homeDriveCount !== 0) {
      writer.uint32(408).int32(message.homeDriveCount);
    }
    if (message.awayDriveCount !== 0) {
      writer.uint32(416).int32(message.awayDriveCount);
    }
    if (message.homePlayCount !== 0) {
      writer.uint32(424).int32(message.homePlayCount);
    }
    if (message.awayPlayCount !== 0) {
      writer.uint32(432).int32(message.awayPlayCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SportEventStatusDto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSportEventStatusDto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.clock = EventClockDto.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.periodScores.push(MatchPeriodScoreDto.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.status = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.statusName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.matchStatus = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.matchStatusName = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.homeScore = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.awayScore = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.homePenaltyScore = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.awayPenaltyScore = reader.int32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.homeGamescore = reader.int32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.awayGamescore = reader.int32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.homeLegscore = reader.int32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.awayLegscore = reader.int32();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.currentServer = reader.int32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.expediteMode = reader.bool();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.tiebreak = reader.bool();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.homeSuspend = reader.int32();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.awaySuspend = reader.int32();
          continue;
        }
        case 20: {
          if (tag !== 160) {
            break;
          }

          message.balls = reader.int32();
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.strikes = reader.int32();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.outs = reader.int32();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.bases = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.homeBatter = reader.int32();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.awayBatter = reader.int32();
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.pitcher = reader.string();
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.batter = reader.string();
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.pitchCount = reader.int32();
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.pitchesSeen = reader.int32();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.totalHits = reader.int32();
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.totalPitches = reader.int32();
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.possession = reader.int32();
          continue;
        }
        case 33: {
          if (tag !== 264) {
            break;
          }

          message.position = reader.int32();
          continue;
        }
        case 34: {
          if (tag !== 272) {
            break;
          }

          message.getTry = reader.int32();
          continue;
        }
        case 35: {
          if (tag !== 280) {
            break;
          }

          message.yards = reader.int32();
          continue;
        }
        case 36: {
          if (tag !== 288) {
            break;
          }

          message.getThrow = reader.int32();
          continue;
        }
        case 37: {
          if (tag !== 296) {
            break;
          }

          message.visit = reader.int32();
          continue;
        }
        case 38: {
          if (tag !== 304) {
            break;
          }

          message.remainingReds = reader.int32();
          continue;
        }
        case 39: {
          if (tag !== 312) {
            break;
          }

          message.delivery = reader.int32();
          continue;
        }
        case 40: {
          if (tag !== 320) {
            break;
          }

          message.homeRemainingBowls = reader.int32();
          continue;
        }
        case 41: {
          if (tag !== 328) {
            break;
          }

          message.awayRemainingBowls = reader.int32();
          continue;
        }
        case 42: {
          if (tag !== 336) {
            break;
          }

          message.currentEnd = reader.int32();
          continue;
        }
        case 43: {
          if (tag !== 344) {
            break;
          }

          message.innings = reader.int32();
          continue;
        }
        case 44: {
          if (tag !== 352) {
            break;
          }

          message.over = reader.int32();
          continue;
        }
        case 45: {
          if (tag !== 360) {
            break;
          }

          message.homePenaltyRuns = reader.int32();
          continue;
        }
        case 46: {
          if (tag !== 368) {
            break;
          }

          message.awayPenaltyRuns = reader.int32();
          continue;
        }
        case 47: {
          if (tag !== 376) {
            break;
          }

          message.homeDismissals = reader.int32();
          continue;
        }
        case 48: {
          if (tag !== 384) {
            break;
          }

          message.awayDismissals = reader.int32();
          continue;
        }
        case 49: {
          if (tag !== 392) {
            break;
          }

          message.currentCtTeam = reader.int32();
          continue;
        }
        case 50: {
          if (tag !== 400) {
            break;
          }

          message.periodOfLeader = reader.int32();
          continue;
        }
        case 51: {
          if (tag !== 408) {
            break;
          }

          message.homeDriveCount = reader.int32();
          continue;
        }
        case 52: {
          if (tag !== 416) {
            break;
          }

          message.awayDriveCount = reader.int32();
          continue;
        }
        case 53: {
          if (tag !== 424) {
            break;
          }

          message.homePlayCount = reader.int32();
          continue;
        }
        case 54: {
          if (tag !== 432) {
            break;
          }

          message.awayPlayCount = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SportEventStatusDto {
    return {
      clock: isSet(object.clock) ? EventClockDto.fromJSON(object.clock) : undefined,
      periodScores: globalThis.Array.isArray(object?.periodScores)
        ? object.periodScores.map((e: any) => MatchPeriodScoreDto.fromJSON(e))
        : [],
      status: isSet(object.status) ? globalThis.Number(object.status) : 0,
      statusName: isSet(object.statusName) ? globalThis.String(object.statusName) : '',
      matchStatus: isSet(object.matchStatus) ? globalThis.Number(object.matchStatus) : 0,
      matchStatusName: isSet(object.matchStatusName) ? globalThis.String(object.matchStatusName) : '',
      homeScore: isSet(object.homeScore) ? globalThis.Number(object.homeScore) : 0,
      awayScore: isSet(object.awayScore) ? globalThis.Number(object.awayScore) : 0,
      homePenaltyScore: isSet(object.homePenaltyScore) ? globalThis.Number(object.homePenaltyScore) : 0,
      awayPenaltyScore: isSet(object.awayPenaltyScore) ? globalThis.Number(object.awayPenaltyScore) : 0,
      homeGamescore: isSet(object.homeGamescore) ? globalThis.Number(object.homeGamescore) : 0,
      awayGamescore: isSet(object.awayGamescore) ? globalThis.Number(object.awayGamescore) : 0,
      homeLegscore: isSet(object.homeLegscore) ? globalThis.Number(object.homeLegscore) : 0,
      awayLegscore: isSet(object.awayLegscore) ? globalThis.Number(object.awayLegscore) : 0,
      currentServer: isSet(object.currentServer) ? globalThis.Number(object.currentServer) : 0,
      expediteMode: isSet(object.expediteMode) ? globalThis.Boolean(object.expediteMode) : false,
      tiebreak: isSet(object.tiebreak) ? globalThis.Boolean(object.tiebreak) : false,
      homeSuspend: isSet(object.homeSuspend) ? globalThis.Number(object.homeSuspend) : 0,
      awaySuspend: isSet(object.awaySuspend) ? globalThis.Number(object.awaySuspend) : 0,
      balls: isSet(object.balls) ? globalThis.Number(object.balls) : 0,
      strikes: isSet(object.strikes) ? globalThis.Number(object.strikes) : 0,
      outs: isSet(object.outs) ? globalThis.Number(object.outs) : 0,
      bases: isSet(object.bases) ? globalThis.String(object.bases) : '',
      homeBatter: isSet(object.homeBatter) ? globalThis.Number(object.homeBatter) : 0,
      awayBatter: isSet(object.awayBatter) ? globalThis.Number(object.awayBatter) : 0,
      pitcher: isSet(object.pitcher) ? globalThis.String(object.pitcher) : '',
      batter: isSet(object.batter) ? globalThis.String(object.batter) : '',
      pitchCount: isSet(object.pitchCount) ? globalThis.Number(object.pitchCount) : 0,
      pitchesSeen: isSet(object.pitchesSeen) ? globalThis.Number(object.pitchesSeen) : 0,
      totalHits: isSet(object.totalHits) ? globalThis.Number(object.totalHits) : 0,
      totalPitches: isSet(object.totalPitches) ? globalThis.Number(object.totalPitches) : 0,
      possession: isSet(object.possession) ? globalThis.Number(object.possession) : 0,
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      getTry: isSet(object.getTry) ? globalThis.Number(object.getTry) : 0,
      yards: isSet(object.yards) ? globalThis.Number(object.yards) : 0,
      getThrow: isSet(object.getThrow) ? globalThis.Number(object.getThrow) : 0,
      visit: isSet(object.visit) ? globalThis.Number(object.visit) : 0,
      remainingReds: isSet(object.remainingReds) ? globalThis.Number(object.remainingReds) : 0,
      delivery: isSet(object.delivery) ? globalThis.Number(object.delivery) : 0,
      homeRemainingBowls: isSet(object.homeRemainingBowls) ? globalThis.Number(object.homeRemainingBowls) : 0,
      awayRemainingBowls: isSet(object.awayRemainingBowls) ? globalThis.Number(object.awayRemainingBowls) : 0,
      currentEnd: isSet(object.currentEnd) ? globalThis.Number(object.currentEnd) : 0,
      innings: isSet(object.innings) ? globalThis.Number(object.innings) : 0,
      over: isSet(object.over) ? globalThis.Number(object.over) : 0,
      homePenaltyRuns: isSet(object.homePenaltyRuns) ? globalThis.Number(object.homePenaltyRuns) : 0,
      awayPenaltyRuns: isSet(object.awayPenaltyRuns) ? globalThis.Number(object.awayPenaltyRuns) : 0,
      homeDismissals: isSet(object.homeDismissals) ? globalThis.Number(object.homeDismissals) : 0,
      awayDismissals: isSet(object.awayDismissals) ? globalThis.Number(object.awayDismissals) : 0,
      currentCtTeam: isSet(object.currentCtTeam) ? globalThis.Number(object.currentCtTeam) : 0,
      periodOfLeader: isSet(object.periodOfLeader) ? globalThis.Number(object.periodOfLeader) : 0,
      homeDriveCount: isSet(object.homeDriveCount) ? globalThis.Number(object.homeDriveCount) : 0,
      awayDriveCount: isSet(object.awayDriveCount) ? globalThis.Number(object.awayDriveCount) : 0,
      homePlayCount: isSet(object.homePlayCount) ? globalThis.Number(object.homePlayCount) : 0,
      awayPlayCount: isSet(object.awayPlayCount) ? globalThis.Number(object.awayPlayCount) : 0,
    };
  },

  toJSON(message: SportEventStatusDto): unknown {
    const obj: any = {};
    if (message.clock !== undefined) {
      obj.clock = EventClockDto.toJSON(message.clock);
    }
    if (message.periodScores?.length) {
      obj.periodScores = message.periodScores.map((e) => MatchPeriodScoreDto.toJSON(e));
    }
    if (message.status !== 0) {
      obj.status = Math.round(message.status);
    }
    if (message.statusName !== '') {
      obj.statusName = message.statusName;
    }
    if (message.matchStatus !== 0) {
      obj.matchStatus = Math.round(message.matchStatus);
    }
    if (message.matchStatusName !== '') {
      obj.matchStatusName = message.matchStatusName;
    }
    if (message.homeScore !== 0) {
      obj.homeScore = Math.round(message.homeScore);
    }
    if (message.awayScore !== 0) {
      obj.awayScore = Math.round(message.awayScore);
    }
    if (message.homePenaltyScore !== 0) {
      obj.homePenaltyScore = Math.round(message.homePenaltyScore);
    }
    if (message.awayPenaltyScore !== 0) {
      obj.awayPenaltyScore = Math.round(message.awayPenaltyScore);
    }
    if (message.homeGamescore !== 0) {
      obj.homeGamescore = Math.round(message.homeGamescore);
    }
    if (message.awayGamescore !== 0) {
      obj.awayGamescore = Math.round(message.awayGamescore);
    }
    if (message.homeLegscore !== 0) {
      obj.homeLegscore = Math.round(message.homeLegscore);
    }
    if (message.awayLegscore !== 0) {
      obj.awayLegscore = Math.round(message.awayLegscore);
    }
    if (message.currentServer !== 0) {
      obj.currentServer = Math.round(message.currentServer);
    }
    if (message.expediteMode !== false) {
      obj.expediteMode = message.expediteMode;
    }
    if (message.tiebreak !== false) {
      obj.tiebreak = message.tiebreak;
    }
    if (message.homeSuspend !== 0) {
      obj.homeSuspend = Math.round(message.homeSuspend);
    }
    if (message.awaySuspend !== 0) {
      obj.awaySuspend = Math.round(message.awaySuspend);
    }
    if (message.balls !== 0) {
      obj.balls = Math.round(message.balls);
    }
    if (message.strikes !== 0) {
      obj.strikes = Math.round(message.strikes);
    }
    if (message.outs !== 0) {
      obj.outs = Math.round(message.outs);
    }
    if (message.bases !== '') {
      obj.bases = message.bases;
    }
    if (message.homeBatter !== 0) {
      obj.homeBatter = Math.round(message.homeBatter);
    }
    if (message.awayBatter !== 0) {
      obj.awayBatter = Math.round(message.awayBatter);
    }
    if (message.pitcher !== '') {
      obj.pitcher = message.pitcher;
    }
    if (message.batter !== '') {
      obj.batter = message.batter;
    }
    if (message.pitchCount !== 0) {
      obj.pitchCount = Math.round(message.pitchCount);
    }
    if (message.pitchesSeen !== 0) {
      obj.pitchesSeen = Math.round(message.pitchesSeen);
    }
    if (message.totalHits !== 0) {
      obj.totalHits = Math.round(message.totalHits);
    }
    if (message.totalPitches !== 0) {
      obj.totalPitches = Math.round(message.totalPitches);
    }
    if (message.possession !== 0) {
      obj.possession = Math.round(message.possession);
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    if (message.getTry !== 0) {
      obj.getTry = Math.round(message.getTry);
    }
    if (message.yards !== 0) {
      obj.yards = Math.round(message.yards);
    }
    if (message.getThrow !== 0) {
      obj.getThrow = Math.round(message.getThrow);
    }
    if (message.visit !== 0) {
      obj.visit = Math.round(message.visit);
    }
    if (message.remainingReds !== 0) {
      obj.remainingReds = Math.round(message.remainingReds);
    }
    if (message.delivery !== 0) {
      obj.delivery = Math.round(message.delivery);
    }
    if (message.homeRemainingBowls !== 0) {
      obj.homeRemainingBowls = Math.round(message.homeRemainingBowls);
    }
    if (message.awayRemainingBowls !== 0) {
      obj.awayRemainingBowls = Math.round(message.awayRemainingBowls);
    }
    if (message.currentEnd !== 0) {
      obj.currentEnd = Math.round(message.currentEnd);
    }
    if (message.innings !== 0) {
      obj.innings = Math.round(message.innings);
    }
    if (message.over !== 0) {
      obj.over = Math.round(message.over);
    }
    if (message.homePenaltyRuns !== 0) {
      obj.homePenaltyRuns = Math.round(message.homePenaltyRuns);
    }
    if (message.awayPenaltyRuns !== 0) {
      obj.awayPenaltyRuns = Math.round(message.awayPenaltyRuns);
    }
    if (message.homeDismissals !== 0) {
      obj.homeDismissals = Math.round(message.homeDismissals);
    }
    if (message.awayDismissals !== 0) {
      obj.awayDismissals = Math.round(message.awayDismissals);
    }
    if (message.currentCtTeam !== 0) {
      obj.currentCtTeam = Math.round(message.currentCtTeam);
    }
    if (message.periodOfLeader !== 0) {
      obj.periodOfLeader = Math.round(message.periodOfLeader);
    }
    if (message.homeDriveCount !== 0) {
      obj.homeDriveCount = Math.round(message.homeDriveCount);
    }
    if (message.awayDriveCount !== 0) {
      obj.awayDriveCount = Math.round(message.awayDriveCount);
    }
    if (message.homePlayCount !== 0) {
      obj.homePlayCount = Math.round(message.homePlayCount);
    }
    if (message.awayPlayCount !== 0) {
      obj.awayPlayCount = Math.round(message.awayPlayCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SportEventStatusDto>, I>>(base?: I): SportEventStatusDto {
    return SportEventStatusDto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SportEventStatusDto>, I>>(object: I): SportEventStatusDto {
    const message = createBaseSportEventStatusDto();
    message.clock =
      object.clock !== undefined && object.clock !== null ? EventClockDto.fromPartial(object.clock) : undefined;
    message.periodScores = object.periodScores?.map((e) => MatchPeriodScoreDto.fromPartial(e)) || [];
    message.status = object.status ?? 0;
    message.statusName = object.statusName ?? '';
    message.matchStatus = object.matchStatus ?? 0;
    message.matchStatusName = object.matchStatusName ?? '';
    message.homeScore = object.homeScore ?? 0;
    message.awayScore = object.awayScore ?? 0;
    message.homePenaltyScore = object.homePenaltyScore ?? 0;
    message.awayPenaltyScore = object.awayPenaltyScore ?? 0;
    message.homeGamescore = object.homeGamescore ?? 0;
    message.awayGamescore = object.awayGamescore ?? 0;
    message.homeLegscore = object.homeLegscore ?? 0;
    message.awayLegscore = object.awayLegscore ?? 0;
    message.currentServer = object.currentServer ?? 0;
    message.expediteMode = object.expediteMode ?? false;
    message.tiebreak = object.tiebreak ?? false;
    message.homeSuspend = object.homeSuspend ?? 0;
    message.awaySuspend = object.awaySuspend ?? 0;
    message.balls = object.balls ?? 0;
    message.strikes = object.strikes ?? 0;
    message.outs = object.outs ?? 0;
    message.bases = object.bases ?? '';
    message.homeBatter = object.homeBatter ?? 0;
    message.awayBatter = object.awayBatter ?? 0;
    message.pitcher = object.pitcher ?? '';
    message.batter = object.batter ?? '';
    message.pitchCount = object.pitchCount ?? 0;
    message.pitchesSeen = object.pitchesSeen ?? 0;
    message.totalHits = object.totalHits ?? 0;
    message.totalPitches = object.totalPitches ?? 0;
    message.possession = object.possession ?? 0;
    message.position = object.position ?? 0;
    message.getTry = object.getTry ?? 0;
    message.yards = object.yards ?? 0;
    message.getThrow = object.getThrow ?? 0;
    message.visit = object.visit ?? 0;
    message.remainingReds = object.remainingReds ?? 0;
    message.delivery = object.delivery ?? 0;
    message.homeRemainingBowls = object.homeRemainingBowls ?? 0;
    message.awayRemainingBowls = object.awayRemainingBowls ?? 0;
    message.currentEnd = object.currentEnd ?? 0;
    message.innings = object.innings ?? 0;
    message.over = object.over ?? 0;
    message.homePenaltyRuns = object.homePenaltyRuns ?? 0;
    message.awayPenaltyRuns = object.awayPenaltyRuns ?? 0;
    message.homeDismissals = object.homeDismissals ?? 0;
    message.awayDismissals = object.awayDismissals ?? 0;
    message.currentCtTeam = object.currentCtTeam ?? 0;
    message.periodOfLeader = object.periodOfLeader ?? 0;
    message.homeDriveCount = object.homeDriveCount ?? 0;
    message.awayDriveCount = object.awayDriveCount ?? 0;
    message.homePlayCount = object.homePlayCount ?? 0;
    message.awayPlayCount = object.awayPlayCount ?? 0;
    return message;
  },
};

function createBaseOddsDataList(): OddsDataList {
  return { data: [] };
}

export const OddsDataList: MessageFns<OddsDataList> = {
  encode(message: OddsDataList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.data) {
      OddsData.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OddsDataList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOddsDataList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data.push(OddsData.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OddsDataList {
    return { data: globalThis.Array.isArray(object?.data) ? object.data.map((e: any) => OddsData.fromJSON(e)) : [] };
  },

  toJSON(message: OddsDataList): unknown {
    const obj: any = {};
    if (message.data?.length) {
      obj.data = message.data.map((e) => OddsData.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OddsDataList>, I>>(base?: I): OddsDataList {
    return OddsDataList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OddsDataList>, I>>(object: I): OddsDataList {
    const message = createBaseOddsDataList();
    message.data = object.data?.map((e) => OddsData.fromPartial(e)) || [];
    return message;
  },
};

function createBaseOddsData(): OddsData {
  return {
    code: '',
    value: 0,
    status: 0,
    updateTime: 0,
    marketStatus: 0,
    phase: undefined,
    marketId: '',
    specifiers: '',
  };
}

export const OddsData: MessageFns<OddsData> = {
  encode(message: OddsData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== '') {
      writer.uint32(10).string(message.code);
    }
    if (message.value !== 0) {
      writer.uint32(17).double(message.value);
    }
    if (message.status !== 0) {
      writer.uint32(24).int32(message.status);
    }
    if (message.updateTime !== 0) {
      writer.uint32(32).int64(message.updateTime);
    }
    if (message.marketStatus !== 0) {
      writer.uint32(40).int32(message.marketStatus);
    }
    if (message.phase !== undefined) {
      writer.uint32(48).int32(message.phase);
    }
    if (message.marketId !== '') {
      writer.uint32(58).string(message.marketId);
    }
    if (message.specifiers !== '') {
      writer.uint32(66).string(message.specifiers);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OddsData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOddsData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.value = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.status = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.updateTime = longToNumber(reader.int64());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.marketStatus = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.phase = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.marketId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.specifiers = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OddsData {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : '',
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
      status: isSet(object.status) ? globalThis.Number(object.status) : 0,
      updateTime: isSet(object.updateTime) ? globalThis.Number(object.updateTime) : 0,
      marketStatus: isSet(object.marketStatus) ? globalThis.Number(object.marketStatus) : 0,
      phase: isSet(object.phase) ? globalThis.Number(object.phase) : undefined,
      marketId: isSet(object.marketId) ? globalThis.String(object.marketId) : '',
      specifiers: isSet(object.specifiers) ? globalThis.String(object.specifiers) : '',
    };
  },

  toJSON(message: OddsData): unknown {
    const obj: any = {};
    if (message.code !== '') {
      obj.code = message.code;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    if (message.status !== 0) {
      obj.status = Math.round(message.status);
    }
    if (message.updateTime !== 0) {
      obj.updateTime = Math.round(message.updateTime);
    }
    if (message.marketStatus !== 0) {
      obj.marketStatus = Math.round(message.marketStatus);
    }
    if (message.phase !== undefined) {
      obj.phase = Math.round(message.phase);
    }
    if (message.marketId !== '') {
      obj.marketId = message.marketId;
    }
    if (message.specifiers !== '') {
      obj.specifiers = message.specifiers;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OddsData>, I>>(base?: I): OddsData {
    return OddsData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OddsData>, I>>(object: I): OddsData {
    const message = createBaseOddsData();
    message.code = object.code ?? '';
    message.value = object.value ?? 0;
    message.status = object.status ?? 0;
    message.updateTime = object.updateTime ?? 0;
    message.marketStatus = object.marketStatus ?? 0;
    message.phase = object.phase ?? undefined;
    message.marketId = object.marketId ?? '';
    message.specifiers = object.specifiers ?? '';
    return message;
  },
};

function createBaseOddsRecommendData(): OddsRecommendData {
  return { sportId: '', matchId: '', modes: [] };
}

export const OddsRecommendData: MessageFns<OddsRecommendData> = {
  encode(message: OddsRecommendData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sportId !== '') {
      writer.uint32(10).string(message.sportId);
    }
    if (message.matchId !== '') {
      writer.uint32(18).string(message.matchId);
    }
    writer.uint32(26).fork();
    for (const v of message.modes) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OddsRecommendData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOddsRecommendData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sportId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.matchId = reader.string();
          continue;
        }
        case 3: {
          if (tag === 24) {
            message.modes.push(reader.int32());

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.modes.push(reader.int32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OddsRecommendData {
    return {
      sportId: isSet(object.sportId) ? globalThis.String(object.sportId) : '',
      matchId: isSet(object.matchId) ? globalThis.String(object.matchId) : '',
      modes: globalThis.Array.isArray(object?.modes) ? object.modes.map((e: any) => globalThis.Number(e)) : [],
    };
  },

  toJSON(message: OddsRecommendData): unknown {
    const obj: any = {};
    if (message.sportId !== '') {
      obj.sportId = message.sportId;
    }
    if (message.matchId !== '') {
      obj.matchId = message.matchId;
    }
    if (message.modes?.length) {
      obj.modes = message.modes.map((e) => Math.round(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OddsRecommendData>, I>>(base?: I): OddsRecommendData {
    return OddsRecommendData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OddsRecommendData>, I>>(object: I): OddsRecommendData {
    const message = createBaseOddsRecommendData();
    message.sportId = object.sportId ?? '';
    message.matchId = object.matchId ?? '';
    message.modes = object.modes?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends globalThis.Array<infer U>
    ? globalThis.Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
      ? ReadonlyArray<DeepPartial<U>>
      : T extends {}
        ? { [K in keyof T]?: DeepPartial<T[K]> }
        : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error('Value is larger than Number.MAX_SAFE_INTEGER');
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error('Value is smaller than Number.MIN_SAFE_INTEGER');
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
